import { render, staticRenderFns } from "./LayoutOverviewColumn.vue?vue&type=template&id=cf0870a2&"
import script from "./LayoutOverviewColumn.vue?vue&type=script&lang=ts&"
export * from "./LayoutOverviewColumn.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutOverviewColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
